import styles from "../styles/LocalProjectAddonBanner.module.scss";

export const LocalProjectInfoAU = () => (
  <div className={styles.moreInfoCopy}>
    <p>
      Increase your impact by planting extra trees in Australian soil. Your
      contribution will fund reforestation projects across New South Wales,
      helping to restore habitats and rebuild your iconic landscape.
    </p>
    <ul>
      <li>Plant trees across Australia</li>
      <li>Protect iconic wildlife</li>
      <li>Updates and news from the projects</li>
    </ul>
  </div>
);
